/**
 * @flow
 */

import {
  ON_BETA_DASHBOARD_FETCH_BALANCES_SUCCESS,
  ON_BETA_DASHBOARD_MOUNT,
  ON_BETA_DASHBOARD_MOUNT_ERROR
} from '../actions';

const initialState = {
  loading: false,
  data: []
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_BETA_DASHBOARD_MOUNT:
      return Object.assign({}, state, {
        loading: true
      });

    case ON_BETA_DASHBOARD_MOUNT_ERROR:
      return initialState;

    case ON_BETA_DASHBOARD_FETCH_BALANCES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers/balances.js